<div class="litmus-response-downloader-modal-container">
    <div class="blank-sapce" (click)="closeModal()"> </div>
    <div class="litmus-response-downloader-modal">
        <div class="litmus-response-downloader-header">
            <div class="downloader-header-left">
                <ul class="response-dowloader-tabs">
                    <li class="response-dowloader-tab active" [class.active]="activeTab == 'new_request'"
                        (click)="changeTab('new_request')"> New Request </li>
                    <li class="response-dowloader-tab" [class.active]="activeTab == 'my_download'"
                        (click)="changeTab('my_download')"> My Downloads </li>
                </ul>
            </div>
            <div class="downloader-header-right">
                <button (click)="closeModal()">
                    <img src="assets/images/close.svg" />
                </button>
            </div>
        </div>
        <div class="litmus-response-downloader-body">

            <div class="response-dowloader-tab-content">
                <div class="response-dowloader-content my-download-tab" [class.active]="activeTab == 'my_download'">
                    <div class="response-dowloader-note">
                        <div class="notes-icon">
                            <img src="assets/images/engagement-banner-image.svg">
                        </div>
                        <div class="notes-container">
                            <span class="notes">
                                <span class="note-label">Download History:</span> <span class="note-text">View details
                                    and
                                    history of your previous Response Downloads in the table below.</span>
                            </span>
                            <span class="notes">
                                <span class="note-label">Re-Download Notes:</span> <span class="note-text"> Re-clicking
                                    a filename won’t update details like Status, Assignee, Notes, etc.</span>
                            </span>
                            <span class="notes">
                                <span class="note-label">Link Expiry: </span> <span class="note-text">The download link
                                    is only valid for 24 hours from when it’s created.</span>
                            </span>
                            <span class="notes">
                                <span class="note-label">New Report: </span> <span class="note-text">To download a new
                                    file, proceed to New Request tab.</span>
                            </span>
                        </div>
                    </div>
                    <div class="response-downloader-loader" *ngIf="loadingTableData">
                        <app-ltms-loader></app-ltms-loader>
                    </div>
                    <app-ltms-data-table-v2 [columns]="columns" *ngIf="!loadingTableData" [data]="adrdata"
                        [errorCode]="'404'" (onSelect)="downloadFile($event)"></app-ltms-data-table-v2>
                </div>
                <div class="response-dowloader-content padding-0" [class.active]="activeTab == 'new_request'">
                    <div class="response-field-selector-body">
                        <div class="response-dowloader-desclaimer">
                            Here are the columns, all selected by default. Uncheck any you don’t need, or click ‘Restore
                            Default’ to reset.
                        </div>
                        <div class="response-dowloader-filters">
                            <button [disabled]="!(fieldDefinitions && fieldDefinitions.length)" (click)="toggaleDownloadFields($event)">{{(isAllFieldSelected)?'Deselect
                                all':'Select all'}}</button>
                            <div class="response-dowloader-search">
                                <img class="search-icon" src="assets/images/magnify.svg">
                                <input type="text" (keyup)="filterFields($event)" [(ngModel)]="searchText"
                                    placeholder="Search column" />
                                <button class="clear-icon" *ngIf="searchText != ''" (click)="clearSearch()">
                                    <img src="assets/images/close.svg" />
                                </button>
                            </div>
                        </div>
                        <div class="response-dowloader-fields"
                            *ngIf="isFieldListLoaded && isFieldsAvaible && fieldDefinitions.length" cdkDropList
                            cdkScrollable (cdkDropListDropped)="drop($event)">
                            <div class="response-dowloader-field" [cdkDragDisabled]="searchText != ''" cdkDrag
                                *ngFor="let field of fieldDefinitions">
                                <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
                                <img *ngIf="searchText == ''" src="assets/images/drag-icon.svg" />
                                <label [for]="field.field_id" (click)="updateIncludeFields($event,field)">
                                    {{field.name}}
                                    <!-- <input [id]="field.field_id" type="checkbox" (change)="updateIncludeFields($event,field)" [checked]="(field.download)" /> -->
                                    <img *ngIf="!field.download" src="assets/images/checkbox-blank-outline.svg" />
                                    <img *ngIf="field.download" src="assets/images/checkbox-marked.svg" />
                                </label>

                            </div>
                        </div>
                        <div *ngIf="isFieldListLoaded && !isFieldsAvaible">
                            <app-ltms-error [code]="'404'"></app-ltms-error>
                        </div>
                        <div *ngIf="isFieldListLoaded && isFieldsAvaible && !fieldDefinitions.length"
                            class="no-search-data">
                            No results found. Please try searching again with a different input.
                        </div>
                        <div class="response-downloader-loader" *ngIf="!isFieldListLoaded">
                            <app-ltms-loader></app-ltms-loader>
                        </div>
                    </div>
                    <div class="response-field-selector-footer" *ngIf="activeTab == 'new_request'">
                        <div class="downloader-footer-left">
                            <button [disabled]="isResetInProgress" (click)="updateReportDownloadSettings($event,true)">
                                <span class="circle-loader" *ngIf="isResetInProgress"></span>
                                <span *ngIf="!isResetInProgress">Restore Default</span>
                            </button>
                        </div>
                        <div class="downloader-footer-right">
                            <button class="secondary-btn"
                                [disabled]="!(includedFields && includedFields.length) || isSavingInProgress"
                                (click)="updateReportDownloadSettings($event)">
                                <span class="circle-loader" *ngIf="isSavingInProgress"></span>
                                <span *ngIf="!isSavingInProgress">Save settings </span>
                            </button>
                            <button class="primary-btn"
                                [disabled]="!(includedFields && includedFields.length) || !reCAPTCHAToken || sendingReport"
                                (click)="emailReport()">
                                <span class="circle-loader" *ngIf="sendingReport"></span>
                                <span *ngIf="!sendingReport"> Email report</span>
                            </button>
                        </div>
                    </div>
                    <!-- <div class="response-dowloader-form">
                        <div class="excluded-fields-container">
                            <div class="excluded-fields" *ngFor="let field of excludedFields">
                                {{field.name}} <img (click)="addInIncludedFields(field)"
                                    src="assets/images/angle-right.svg">
                            </div>
                        </div>
                        <div class="field-mover-container">
                            <button (click)="addAllInExcluded()">
                                <img src="assets/images/angle-double-left.svg" />
                            </button>
                            <button (click)="addAllInIncluded()">
                                <img src="assets/images/angle-double-right.svg" />
                            </button>
                        </div>
                        <div class="included-fields-container">
                            <div class="included-fields" *ngFor="let field of includedFields">
                                <img (click)="addInExcludedFields(field)"
                                    src="assets/images/angle-left.svg"> {{field.name}}
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>

    </div>
</div>